import React, { useEffect, useRef, useState } from 'react'
import user from '../../images/image (32).png'
import search from '../../images/search-interface-symbol (3) 1.png'
import filter from '../../images/sort (2) 1.png'
import toast from 'react-hot-toast'
import HttpClient from '../../utils/HttpClient'
import { formatDateTime } from '../../Helper/Helper'
import { FaEye } from 'react-icons/fa'
import TaskPopUp from './TaskPopUp'
import { reactLocalStorage } from 'reactjs-localstorage'

const UserPermission = ({ getTaskData }) => {
    const [userWiseProjects, setUserWiseProjects] = useState([]);
    const [originalProjects, setOriginalProjects] = useState([]); // To store original unfiltered data
    const [budgets, setBudgets] = useState([]);
    const [milestones, setMilestones] = useState([]);
    const [showBudgetModal, setShowBudgetModal] = useState(false);
    const [showMilestoneModal, setShowMilestoneModal] = useState(false);
    const [projectNameFilter, setProjectNameFilter] = useState('');
    const [userNameFilter, setUserNameFilter] = useState('');
    const [projects, setProjects] = useState([]);
    const [isTask, setIsTask] = useState(true);
    const [taskval, setTaskVal] = useState('');
    const [userList, setUserList] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [isTaskWiseView, setIsTaskWiseView] = useState(true);
    const [modala, setModala] = useState(false);
    const [modalb, setModalb] = useState(false);
    const [taskDetailData, setTaskDetailData] = useState(null);
    const [teamMembers, setTeamMembers] = useState([]); // New state for team members
    const [tasks, setTasks] = useState([]); // New state for tasks
    const [showTeamMembers, setShowTeamMembers] = useState(false); // New state for showing team members
    const [showTasks, setShowTasks] = useState(false); // New state for showing tasks
    const [selectedProjectName, setSelectedProjectName] = useState(''); // New state for selected project name
    const fetchAllProjects = async () => {
        try {
            const res = await HttpClient.requestData('view-all-project', 'GET');
            if (res && res?.status) {
                setProjects(res?.data);
            } else {
                setProjects([]);
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            setProjects([]);
            toast.error(error?.message || 'something went wrong!!!');
        }
    };

    useEffect(() => {
        fetchAllProjects();
    }, []);

    const toggleBudgetModal = () => {
        setShowBudgetModal(!showBudgetModal);
    };

    const toggleMilestoneModal = () => {
        setShowMilestoneModal(!showMilestoneModal);
    };

    const toggleTeamMembersModal = () => {
        setShowTeamMembers(!showTeamMembers);
    };

    const toggleTaskModal = () => {
        setShowTasks(!showTasks);
    }

    const fetchUserWiseProjects = async () => {
        try {
            const res = await HttpClient.requestData('invitedprojectdetails', 'POST', {
                task: isTask,
            });

            if (res && res?.status) {
                // Check if response is for task-wise (array) or project-wise (object with users array)
                if (Array.isArray(res.data)) {
                    // Task-wise view (original logic)
                    setIsTaskWiseView(true);
                    setUserWiseProjects(res.data);
                    setOriginalProjects(res.data);
                    setUserList([]); // Clear user list data
                } else if (res.data.users && Array.isArray(res.data.users)) {
                    // Project-wise view (new structure)
                    setIsTaskWiseView(false);
                    setUserList(res.data.users);
                    setOriginalProjects(res.data.users); // Store users for filtering
                    setUserWiseProjects([]); // Clear task-wise data

                    // Auto-select the first user if available
                    if (res.data.users.length > 0) {
                        const firstUserId = res.data.users[0].user._id;
                        setSelectedUser(firstUserId);
                        const selectedUserData = res.data.users.find(user => user.user._id === firstUserId);
                        if (selectedUserData) {
                            setUserWiseProjects(selectedUserData.tasks || []);
                        }
                    }
                } else {
                    setUserWiseProjects([]);
                    setOriginalProjects([]);
                    setUserList([]);
                    toast.error('Unexpected response format');
                }
            } else {
                setUserWiseProjects([]);
                setOriginalProjects([]);
                setUserList([]);
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
            setUserWiseProjects([]);
            setOriginalProjects([]);
            setUserList([]);
        }
    };

    useEffect(() => {
        fetchUserWiseProjects();
    }, [isTask]);

    // Filter function for task-wise view
    const applyFiltersForProject = (projectNameFilter = '') => {
        let filtered = [...originalProjects];

        filtered = filtered.filter(project =>
            project.projectName?.toLowerCase().includes(projectNameFilter.toLowerCase())
        );
        setUserWiseProjects(filtered);
    };

    const applyFiltersForUsers = (userNameFilter = '') => {
        let filtered = [...originalProjects];

        filtered = filtered.filter(project =>
            project.clientName?.toLowerCase().includes(userNameFilter.toLowerCase())
        );

        setUserWiseProjects(filtered);
    };

    // Filter function for project-wise view (users)
    const applyUserFilter = (userNameFilter = '') => {
        let filtered = [...originalProjects];

        filtered = filtered.filter(user =>
            user.user?.name?.toLowerCase().includes(userNameFilter.toLowerCase()) ||
            user.user?.email?.toLowerCase().includes(userNameFilter.toLowerCase())
        );
        setUserList(filtered);
    };

    // Handle user selection for project-wise view
    const handleUserSelect = (userId) => {
        setSelectedUser(userId);
        const selectedUserData = originalProjects.find(user => user.user._id === userId);
        if (selectedUserData) {
            setUserWiseProjects(selectedUserData.tasks || []);
        }
    };

    useEffect(() => {
        if (isTaskWiseView) {
            if (projectNameFilter) {
                applyFiltersForProject(projectNameFilter);
            }
            if (userNameFilter) {
                applyFiltersForUsers(userNameFilter);
            }
        } else {
            if (userNameFilter) {
                applyUserFilter(userNameFilter);
            }
        }
    }, [projectNameFilter, userNameFilter, isTaskWiseView]);

    useEffect(() => {
        if (taskval && taskval === 'user') {
            setIsTask(false);
            setProjectNameFilter('');
            setUserNameFilter('');
            setSelectedUser('');
        } else {
            setIsTask(true);
            setProjectNameFilter('');
            setUserNameFilter('');
            setSelectedUser('');
        }
    }, [taskval]);

    // Create a custom hook
    const useOutsideClick = (ref, callback) => {
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    callback();
                }
            };

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, callback]);
    };

    const milestoneRef = useRef();
    const budgetDetailsRef = useRef();
    const teamMemberRef = useRef();

    useOutsideClick(milestoneRef, () => {
        if (showMilestoneModal) {
            setShowMilestoneModal(false);
        }
    });

    useOutsideClick(budgetDetailsRef, () => {
        if (showBudgetModal) {
            setShowBudgetModal(false);
        }
    });

    useOutsideClick(teamMemberRef, () => {
        if (showTeamMembers) {
            setShowTeamMembers(false);
        }
    });

    return (
        <>
            <div className='user_permission_wrapper'>
                <div className='user_access_head'>Project Quick View</div>
                <div className='user_permission_table_Wrapper'>
                    <div className='team_search_wrapper'>
                        <h6 style={{
                            fontSize: '25px'
                        }}>Project Quick View</h6>
                        <div className='user_search_input_wrapper' style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            gap: '10px'
                        }}>
                            <div className='user_Search_input_div'>
                                <select name='viewType' value={taskval} onChange={(e) => {
                                    setTaskVal(e.target.value);
                                }}>
                                    <option value={'task'}>Task Wise</option>
                                    <option value={'user'}>User Wise</option>
                                </select>
                            </div>

                            {isTaskWiseView ? (
                                <>
                                    <div className='user_Search_input_div'>
                                        <select name='projectId' value={projectNameFilter} onChange={(e) => {
                                            setProjectNameFilter(e.target.value);
                                            applyFiltersForProject(e.target.value);
                                        }}>
                                            <option value=''>All projects</option>
                                            {
                                                projects?.length > 0 ? projects?.map((e, i) => (
                                                    <option key={e?._id} value={e?.projectName}>{e?.projectName || '-'}</option>
                                                )) : (<option value=''>No Projects Found ...</option>)
                                            }
                                        </select>
                                    </div>
                                    <div className='user_Search_input_div'>
                                        <input
                                            type='text'
                                            placeholder='Filter by Client Name'
                                            value={userNameFilter}
                                            onChange={(e) => {
                                                setUserNameFilter(e.target.value);
                                                applyFiltersForUsers(e.target.value);
                                            }}
                                        />
                                        <img
                                            src={search}
                                            alt='Search'
                                            style={{ cursor: 'pointer', width: '15%', height: '20%', marginTop: '8px' }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='user_Search_input_div'>
                                        <input
                                            type='text'
                                            placeholder='Filter by User Name/Email'
                                            value={userNameFilter}
                                            onChange={(e) => {
                                                setUserNameFilter(e.target.value);
                                                applyUserFilter(e.target.value);
                                            }}
                                        />
                                        <img
                                            src={search}
                                            alt='Search'
                                            style={{ cursor: 'pointer', width: '15%', height: '20%', marginTop: '8px' }}
                                        />
                                    </div>
                                    {userList.length > 0 && (
                                        <div className='user_Search_input_div'>
                                            <select
                                                value={selectedUser}
                                                onChange={(e) => handleUserSelect(e.target.value)}
                                            >
                                                <option value="">Select User</option>
                                                {userList.map((userData) => (
                                                    <option key={userData.user._id} value={userData.user._id}>
                                                        {userData.user.name} - {userData.user.email}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {isTaskWiseView ? (
                        // Task-wise table (original structure)
                        <table className='user_permission_table'>
                            <thead className='thead_row'>
                                <tr className='thead_row'>
                                    <th className='user_table_head1'>ID</th>
                                    <th className='user_table_head2'>Project Members</th>
                                    <th className='user_table_head3'>Project Name</th>
                                    <th className='user_table_head4'>Project Notes</th>
                                    <th className='user_table_head4'>Project Status</th>
                                    <th className='user_table_head4'>Start Date</th>
                                    <th className='user_table_head4'>End Date</th>
                                    <th className='user_table_head4'>Client Name</th>
                                    <th className='user_table_head4'>Client Email</th>
                                    <th className='user_table_head4'>Total Budget</th>
                                    <th className='user_table_head4'>Currency</th>
                                    <th className='user_table_head4'>Budget Details</th>
                                    <th className='user_table_head4'>Budget As Of Now</th>
                                    <th className='user_table_head5'>Milestone</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userWiseProjects?.length > 0 ? userWiseProjects?.map((e, i) => {
                                    return (
                                        <tr key={i}>
                                            <td><div className='id_wrapper'>
                                                {(i + 1)}
                                            </div> </td>
                                            {/* <td>{e?.userId?.name || '-'}</td> */}
                                            <td
                                                onClick={() => {
                                                    setTeamMembers(e?.assignToUser || []);
                                                    toggleTeamMembersModal();
                                                    setSelectedProjectName(e?.projectName || '');
                                                }}
                                            ><FaEye style={{ cursor: 'pointer' }} /></td>
                                            <td>{e?.projectName || '-'}</td>
                                            <td>{e?.projectNotes || '-'}</td>
                                            <td>{e?.projectStatus || '-'}</td>
                                            <td>{e?.startDate ? formatDateTime(e?.startDate) : '-'}</td>
                                            <td>{e?.endDate ? formatDateTime(e?.endDate) : '-'}</td>
                                            <td>{e?.clientName || '-'}</td>
                                            <td>{e?.clientEmail || '-'}</td>
                                            <td>{e?.budget || 0}</td>
                                            <td>{e?.currency || '-'}</td>
                                            <td
                                                onClick={() => {
                                                    setBudgets(e?.budgetDetails || []);
                                                    setShowBudgetModal(!showBudgetModal);
                                                }}
                                            ><FaEye style={{ cursor: 'pointer' }} /></td>
                                            <td>{e?.nowbudget || '-'}</td>
                                            <td
                                                onClick={() => {
                                                    setMilestones(e?.milestones || []);
                                                    setShowMilestoneModal(!showMilestoneModal);
                                                }}
                                            ><FaEye style={{ cursor: 'pointer' }} /></td>
                                        </tr>
                                    )
                                }) : (
                                    <tr>
                                        <td colSpan={14} style={{ textAlign: 'center' }}>
                                            No Data Found...
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    ) : (
                        // Project-wise table (new structure)
                        <>
                            {selectedUser ? (
                                <table className='user_permission_table'>
                                    <thead className='thead_row'>
                                        <tr className='thead_row'>
                                            <th className='user_table_head1'>ID</th>
                                            <th className='user_table_head2'>Task Name</th>
                                            <th className='user_table_head3'>Task Notes</th>
                                            <th className='user_table_head4'>Task Status</th>
                                            <th className='user_table_head4'>Project Name</th>
                                            <th className='user_table_head4'>Project Status</th>
                                            <th className='user_table_head4'>Client Name</th>
                                            <th className='user_table_head4'>Client Email</th>
                                            <th className='user_table_head4'>Project OverAll Budget</th>
                                            <th className='user_table_head4'>Now Budget</th>
                                            <th className='user_table_head4'>Start Date</th>
                                            <th className='user_table_head4'>End Date</th>
                                            <th className='user_table_head4'>Budget Details</th>
                                            <th className='user_table_head4'>Milestone</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userWiseProjects?.length > 0 ? userWiseProjects?.map((task, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td><div className='id_wrapper'>{(i + 1)}</div></td>
                                                    <td onClick={() => {
                                                        setModala(true);
                                                        setTaskDetailData(task);
                                                    }}>{task.taskName || '-'}</td>
                                                    <td>{task.taskNotes || '-'}</td>
                                                    <td>{task.taskStatus || '-'}</td>
                                                    <td>{task.assignToProject?.projectName || '-'}</td>
                                                    <td>{task.assignToProject?.projectStatus || '-'}</td>
                                                    <td>{task.assignToProject?.clientName || '-'}</td>
                                                    <td>{task.assignToProject?.clientEmail || '-'}</td>
                                                    <td>{task.assignToProject?.budget || 0}</td>
                                                    <td>{task.assignToProject?.nowbudget || 0}</td>
                                                    <td>{task.selectDate ? formatDateTime(task.selectDate) : '-'}</td>
                                                    <td>{task.endDate ? formatDateTime(task.endDate) : '-'}</td>
                                                    <td
                                                        onClick={() => {
                                                            setBudgets(task?.assignToProject?.budgetDetails || []);
                                                            setShowBudgetModal(!showBudgetModal);
                                                        }}
                                                    ><FaEye style={{ cursor: 'pointer' }} /></td>
                                                    <td
                                                        onClick={() => {
                                                            setMilestones(task?.assignToProject?.milestones || []);
                                                            setShowMilestoneModal(!showMilestoneModal);
                                                        }}
                                                    ><FaEye style={{ cursor: 'pointer' }} /></td>
                                                </tr>
                                            )
                                        }) : (
                                            <tr>
                                                <td colSpan={14} style={{ textAlign: 'center' }}>
                                                    No Tasks Found for Selected User...
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                    Please select a user to view their tasks
                                </div>
                            )}
                        </>
                    )}
                </div>
                {/* Budget Details Modal */}
                {showBudgetModal && (
                    <div className="modal-overlay" ref={budgetDetailsRef} onClick={(e) => {
                        // Only close if clicking directly on the overlay (not on the modal content)
                        if (e.target === e.currentTarget) {
                            toggleBudgetModal();
                        }
                    }}>
                        <div className="budget-modal">
                            <div className="modal-header">
                                <h3>Budget Breakdown</h3>
                                <button className="close-modal" onClick={toggleBudgetModal}>
                                    <i className="fa-solid fa-x"></i>
                                </button>
                            </div>
                            <div className="table-container">
                                <table className="budget-table">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Amount</th>
                                            {
                                                reactLocalStorage.getObject('userData')?.userType === "Business" && (<th>My Profit</th>)
                                            }
                                            {
                                                reactLocalStorage.getObject('userData')?.userType === "Business" && (<th>To Be Used</th>)
                                            }
                                            <th>Notes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {budgets?.length > 0 ? budgets?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.title || '-'}</td>
                                                <td>{item.amount || 0}</td>
                                                {
                                                    reactLocalStorage.getObject('userData')?.userType === "Business" && (<td>{item.myProfit || 0}</td>)
                                                }
                                                {
                                                    reactLocalStorage.getObject('userData')?.userType === "Business" && (<td>{item.toBeUsed || 0}</td>)
                                                }
                                                <td>{item.notes || '-'}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: 'center' }}>
                                                    No Budget Details Data Found ...
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}

                {/* Team Member Related Modal */}
                {showTeamMembers && (
                    <div className="modal-overlay" ref={teamMemberRef} onClick={(e) => {
                        // Only close if clicking directly on the overlay (not on the modal content)
                        if (e.target === e.currentTarget) {
                            toggleTeamMembersModal();
                        }
                    }}>
                        <div className="budget-modal">
                            <div className="modal-header">
                                <h3>Team Member Details</h3>
                                <button className="close-modal" onClick={toggleTeamMembersModal}>
                                    <i className="fa-solid fa-x"></i>
                                </button>
                            </div>
                            <div className="table-container">
                                <table className="budget-table">
                                    <thead>
                                        <tr>
                                            <th>Member Name</th>
                                            <th>NO Of Task Assigned</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {teamMembers?.length > 0 ? teamMembers?.map(item => (
                                            <tr key={item._id}>
                                                <td>{item.name || '-'}</td>
                                                <td
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontWeight: 600,
                                                        color: item?.tasks?.length > 0 ? 'blue' : 'gray'
                                                    }}
                                                    onClick={() => {
                                                        setTasks(item?.tasks || []);
                                                        toggleTaskModal();
                                                    }}
                                                >{item?.tasks?.length || 0}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: 'center' }}>
                                                    No Team Member Data Found ...
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Tasks Details Modal */}
                        {showTasks && (
                            <div className="modal-overlay" onClick={(e) => e.stopPropagation()}>
                                <div className="budget-modal" onClick={(e) => e.stopPropagation()}>
                                    <div className="modal-header">
                                        <h3>Tasks Details</h3>
                                        <button className="close-modal" onClick={e => {
                                            e.stopPropagation();
                                            toggleTaskModal();
                                        }}>
                                            <i className="fa-solid fa-x"></i>
                                        </button>
                                    </div>
                                    <div className="table-container">
                                        <table className="budget-table">
                                            <thead>
                                                <tr>
                                                    <th>Task Name</th>
                                                    <th>Task Notes</th>
                                                    <th>Task Status</th>
                                                    <th>View More</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tasks?.length > 0 ? tasks?.map(item => (
                                                    <tr key={item._id}>
                                                        <td>{item.taskName || '-'}</td>
                                                        <td>{item.taskNotes || '-'}</td>
                                                        <td>{item.taskStatus || '-'}</td>
                                                        <td
                                                            onClick={() => {
                                                                setTaskDetailData(item);
                                                                setModalb(!modalb);
                                                            }}
                                                        ><FaEye style={{ cursor: 'pointer' }} /></td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan={5} style={{ textAlign: 'center' }}>
                                                            No Task Details Data Found ...
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Milestone Modal */}
            {showMilestoneModal && (
                <div className="modal-overlay" ref={milestoneRef} onClick={(e) => {
                    // Only close if clicking directly on the overlay (not on the modal content)
                    if (e.target === e.currentTarget) {
                        toggleMilestoneModal();
                    }
                }}>
                    <div className="budget-modal">
                        <div className="modal-header">
                            <h3>Milestone Breakdown</h3>
                            <button className="close-modal"
                                onClick={toggleMilestoneModal}>
                                <i className="fa-solid fa-x"></i>
                            </button>
                        </div>
                        <div className="table-container">
                            <table className="budget-table">
                                <thead>
                                    <tr>
                                        <th>Milestone Name</th>
                                        <th>Amount</th>
                                        <th>Project Budget</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {milestones?.length > 0 ? milestones?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.milestoneName || '-'}</td>
                                            <td>{item.amount || 0}</td>
                                            <td>{item.projectbudget || 0}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={3} style={{ textAlign: 'center' }}>
                                                No Milestone Data Found ...
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {modala && <TaskPopUp closemodal={setModala} getTaskData={getTaskData} fetchEntireTask={fetchUserWiseProjects} detailData={{
                ...taskDetailData,
                assignToProject: taskDetailData?.assignToProject?.projectName || '',
            }} isFromTaskList={false} />}

            {modalb && <TaskPopUp closemodal={() => {
                setModalb(false);
                toggleTaskModal();
                toggleTeamMembersModal();
                fetchUserWiseProjects();
            }} getTaskData={getTaskData} fetchEntireTask={fetchUserWiseProjects} detailData={{
                ...taskDetailData,
                assignToProject: selectedProjectName || '',
            }} isFromTaskList={true} isZIndex={true} />}

        </>
    )
}

export default UserPermission;